module.exports = __webpack_public_path__ + "static/media/cagdas.62d86ddd.jpg";